// Section file — /50off cold-traffic funnel.
// Must keep an IDENTICAL key tree with es.fiftyoff.js.

const lang = {
  fiftyoff: {
    bannerPrefix: "Limited time:",
    bannerOff: "50% off",
    bannerEndsIn: "ends in",
    trustedBy: "Trusted by 50,000+ creators",
    // The package is one-time; the auto-refill service that comes with it
    // renews at $19.99 (7 days, then every 28). So nothing here may claim the
    // buyer will never be billed again — that is the statement a dispute turns
    // on — and nothing may promise the package itself delivers monthly.
    heroHeading: "Get real followers on your account today",
    heroSub:
      "Pick how many followers you want and we deliver them to your Instagram, TikTok or X. One-time purchase — 50% off today only.",
    perMonth: "/mo",
    followersPerMonth: (range) => `${range} followers`,
    // Quality tiers, chosen after the package. Prices are the package price
    // times 1/2/3, rounded to the next .99 (config/packages.js qualityPrice).
    quality: {
      heading: "Choose your follower quality",
      tiers: {
        high: {
          name: "High Quality Followers",
          badge: "Best Value",
          desc: "These are Followers with profile pictures but no further uploads on their account. Auto-refill is enabled within the warranty.",
          features: [
            "Genuine followers related to your niche",
          ],
        },
        active: {
          name: "Active Followers",
          badge: "Popular",
          desc: "New Active followers are for those who are serious about their Instagram growth. These are backed by our refill guarantee for added peace of mind.",
          features: [
            "Real and engaged followers",
            "Priority support",
          ],
        },
        vip: {
          name: "Exclusive/VIP Followers",
          badge: "Premium",
          desc: "Fit for our most VIP Instagrammers! VIP followers are our highest quality packages, all from North America geo targeted and highly active, with real engagement, interactive stories, dynamic carousels, no ghost profiles, and have 5-10x more followers than following.",
          features: [
            "AI-Targeted Followers for strong growth",
            "Priority support",
          ],
        },
      },
    },
    mostPopular: "Most popular",
    gainWillGain: (u) => `@${u} Will Gain:`,
    gainNewCount: "New Follower Count:",
    gainFollowers: "Followers",
    continueBtn: "Continue",
    changeBtn: "Change",
    doneBtn: "Done",
    accountLabel: "Account to grow",
    cardAccordion: "Pay with credit or debit card",
    startMyGrowth: "Start my growth",
    startGrowing: "Start Growing",
    secureLine: "Secure checkout · Cancel auto-refill anytime",
    guaranteeHeading: "7-Day Money Back Guarantee",
    guaranteeBody: "Try ViralGPT risk-free. If you're not completely satisfied within 7 days, we'll give you a full refund—",
    guaranteeBold: "no questions asked.",
    changePlan: "Change plan",
    offApplied: "50% launch discount applied",
    billingHeading: "Start your growth",
    emailLabel: "Email address",
    emailPlaceholder: "you@email.com",
    platformLabel: "Platform",
    usernameLabel: (platform) => `${platform} username`,
    usernamePlaceholder: "@username",
    cardLabel: "Card number",
    expirationLabel: "Expiration",
    cvcLabel: "CVC",
    orderSummary: "Order summary",
    // The order line names what is being delivered, not the internal plan key.
    // "Core" / "Elite" are names the buyer never chose — they picked a count.
    planLineFollowers: (n) => `${n} followers`,
    launchDiscount: "50% launch discount",
    // Auto-refill. Disclosed inside the order summary, under the total.
    autoRefillLabel: (p) => `Keep my account growing — $${p}/month`,
    autoRefillDisclosure: (trial, cycle) => `Starts in ${trial} days. Renews every ${cycle} days. Cancel anytime.`,
    // Checkout-only name for the usa addon — the visualizer toggle keeps its own.
    addonUsa: "USA targeting",
    dueToday: "Due today",
    processing: "Processing...",
    secureCheckout: "Secure checkout",
    errEmail: "Please enter a valid email address.",
    errUsername: "Please enter your username.",
    errUsernameIsEmail: (platform) => `Please enter your ${platform} username, not your email address.`,
    errGeneric: "Something went wrong. Please try again.",
    loginPrompt: "You already have an account with this email. Enter your password to continue.",
    loginPasswordPlaceholder: "Your password",
    loginCta: "Log in and continue",
    loginPasswordRequired: "Please enter your password.",
    successHeading: "You're all set!",
    successBody: (handle) => `We're starting growth on @${handle} right now. Create a password to access your dashboard.`,
    passwordPlaceholder: "Create a password (8+ characters)",
    passwordTooShort: "Password must be at least 8 characters.",
    goToDashboard: "Go to my dashboard",
    // One-click engagement add-on on the success screen.
    engagementTitle: (n) => `Your ${n} new followers are arriving`,
    engagementSub: "Add likes and views so your posts don\u2019t look flat — 5,000 likes and 10,000 views, spread across your recent posts.",
    engagementCta: "Add for $9.98",
    engagementDone: "Engagement is on its way to your recent posts.",
    // Half the package again at half its price — the same rate per follower
    // the package sells at. States the quantity, since that is what ships.
    upgradeFollowers: (n) => `Add ${n} more followers`,
    upgradeFollowersLine: (n) => `+${n} followers`,
    upgradeFollowersSub: "Same rate as your package — delivered with your order.",
    boostEngagement: "Boost Engagement+",
    boostEngagementSub: "Extra views & reach on every post",
    planMicro: "Starter",
    planInfluencer: "Core",
    planBusiness: "Elite",
    featStarterFollowers: "200 followers",
    featStarterTargeting: "AI audience targeting",
    featStarterNoPassword: "No password required",
    featStarterCancel: "Cancel anytime",
    featBasicFollowers: "1,200 followers",
    featBasicTargeting: "Enhanced AI audience targeting",
    featBasicTools: "AI Content Assistant",
    featBasicEngagement: "Priority support",
    featGrowthStarts: "Follower growth starts instantly",
    featProPriority: "Priority support & delivery",
    featProFollowers: "4,000 followers",
    featProTargeting: "Premium AI audience targeting",
    featProManager: "Dedicated Account Manager",
    summaryFollowersStarter: "200 followers",
    summaryFollowersBasic: "1,200 followers",
    summaryFollowersPro: "4,000 followers",
  },
};

export default lang;
